import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { container } from '@Container';
import { Locale } from '@Repository/locale';
import { TYPES } from '@Types';
//@ts-ignore
import img_all_versions from '@Images/en/all_versions.png';
//@ts-ignore
import img_battle from '@Images/en/version_battle.png';
import { ContestView } from '@Selectors/builder/myBuilder/show/view/ContestView';

interface IMyContestComponentProps {
  contest: ContestView;
}

const ContestComponent: React.FC<MyContestComponentProps> = ({ contest }) => {
  const locale = container.get<Locale>(TYPES.Locale);
  const currentLocale = locale.getlocale();

  return (
    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 Contest cursor-pointer contest_list_row">
      <a href={`/${currentLocale}/tournament/my_contests/${contest.id}`}>
        {contest.isNinthAge && (
          <img
            className="img-fluid w-100"
            alt={'9Th Age'}
            src={`${process.env.CDN ?? ''}${img_all_versions}`}
          />
        )}
        {contest.isEssenceOfWar && (
          <img
            className="img-fluid w-100"
            alt={'Essence of War'}
            src={`${process.env.CDN ?? ''}${img_all_versions}`}
          />
        )}
        {contest.isWarhammerBattle && (
          <img
            className="img-fluid w-100"
            alt={'Battle'}
            src={`${process.env.CDN ?? ''}${img_battle}`}
          />
        )}
        <h4 className="boxtitre text-center">
          <span className="user-name">{contest.name}</span>
        </h4>
      </a>
    </div>
  );
};

const mapStateToProps = (
  state: AppState,
  owsProps: IMyContestComponentProps
) => ({
  contest: owsProps.contest,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ContestComponent);

type MyContestComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
